<script setup lang="ts">
import FooterNav from '@/widgets/Footer/ui/FooterNav.vue';
import PolicyLinks from '@/shared/ui/PolicyLinks/index';

import { ROOT_LAWYERS_PAGE_URL } from '@/shared/constants/urlConstants';
import { FOOTER_DESCRIPTION, EMBLEM_SRC } from '@/shared/constants/contactConstants';

const route = useRoute();
const isLawyerLanding: ComputedRef<boolean> = computed(
  () => route.name === ROOT_LAWYERS_PAGE_URL,
);
const year: number = new Date().getFullYear();
</script>

<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__top">
        <div class="footer__info">
          <div class="footer__logo">
            <AppLogo is-white />
          </div>
          <div class="footer__info-desc">{{ FOOTER_DESCRIPTION }}</div>
          <div class="footer__accreditation">
            <img
              class="footer__emblem"
              :src="EMBLEM_SRC"
              alt="Герб Российской Федерации"
              width="23"
              height="26"
              loading="lazy"
            />
            <div class="footer__accreditation-text">
              №31264 в реестре аккредитованных организаций Минцифры РФ
            </div>
          </div>
        </div>
        <div class="footer__nav-wrap">
          <FooterNav />
          <div v-if="isLawyerLanding" class="footer__payments">
            <div class="footer__payments-title">Платежные партнеры</div>
            <div class="footer__payments-logo">
              <AppIcon class="footer__payments-icon" name="SbpPay" />
              <AppIcon class="footer__payments-icon" name="MirPay" />
              <AppIcon class="footer__payments-icon" name="VisaPay" />
              <AppIcon class="footer__payments-icon" name="MastercardPay" />
            </div>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <div class="footer__rules">
          <span class="footer__copyright">
            © {{ year }} Юрик.ру, Все права защищены
          </span>
          <div class="footer__policy-links">
            <PolicyLinks />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="less">
.footer {
  background-color: @color-elephant;
  position: relative;
  z-index: 101;
  bottom: 0;

  &__inner {
    .container-d();

    padding-top: 70px;
    padding-bottom: @size-x8;
  }

  &__logo {
    min-width: 139px;
    min-height: 60px;
  }

  &__info-desc {
    position: relative;
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 500;
    color: white;
    max-width: 312px;
    margin-top: @size-x3;
    padding-bottom: @size-x3;

    &::after {
      content: '';
      position: absolute;
      width: 38px;
      background-color: @color-persimmon;
      height: 1px;
      left: 0;
      bottom: 1px;
    }
  }

  &__accreditation {
    display: flex;
    align-items: center;
    margin-top: @size-x10;
    margin-bottom: @size-x10;
  }

  &__accreditation-text {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 500;
    color: white;
    max-width: 250px;
    border-left: 1px solid white;
    padding-left: 10px;
    margin-left: 10px;
  }

  &__payments {
    margin-top: @size-x6;
  }

  &__payments-title {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    color: white;
  }

  &__payments-logo {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  &__payments-icon:not(:last-child) {
    margin-right: @size-x5;
  }

  &__top {
    display: flex;
    justify-content: space-between;
    gap: @size-x5;
  }

  &__rules {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 21px;
    font-weight: 500;
    font-size: @size-x3;
    line-height: @size-x4;
    border-top: 1px solid white;
    padding-top: 15px;
  }

  &__policy-links {
    margin-left: @size-x5;
  }

  &__copyright {
    color: white;
  }
}
</style>
